module.exports = __webpack_public_path__ + "img/upload.89e9f458.svg";